class MainProductSelector extends ProductSelector {
  constructor() {
    super();
    this.querySelector('[data-sticky-button]').addEventListener('click', () =>
      this.submitButton.click(),
    );
    this.setupRechargeSubscriptionAttempts = 0;
    window.setupRechargeSubscriptionActions = this.setupRechargeSubscriptionActions.bind(this);
    window.addEventListener("load", function() {
      //console.log("window loaded");
      window.setupRechargeSubscriptionActions();
    });
  }

  setupRechargeSubscriptionActions() {
    const widget = this.querySelector(".rc-widget");
    if (!widget) {
      console.warn("no rc widget found", this.setupRechargeSubscriptionAttempts);
      this.setupRechargeSubscriptionAttempts++;
      if (this.setupRechargeSubscriptionAttempts < 20) setTimeout(window.setupRechargeSubscriptionActions, 500);
      return;
    }
    const purchaseOptionRadios = widget.querySelectorAll("input[type='radio']");
    const sellingPlanSelect = widget.querySelector("select[name='rc_selling_plan']");
    const submitBtnPriceText = this.querySelector(".product-selector__submit .price .money-price");
    if (!submitBtnPriceText) { console.warn("no submit button price element found"); return; }
    const mobilePriceText = document.querySelector(".product-price-mobile .money-price");
    updatePrice(); // Init
    // Radio Purchase Options
    if (!purchaseOptionRadios) { console.warn("no purchase option radios found"); return; }
    purchaseOptionRadios.forEach(radio => {
      radio.addEventListener("change", e => {
        //console.log("radio change", e.target.value);
        if (e.target.checked) {
          const priceText = getCurrentPrice();
          //console.log("price check",priceText);
          updatePrice(priceText);
        }
      });
    });
    // Select (dropdown) selling plan
    if (!sellingPlanSelect) { console.warn("no selling plan select found"); return; }
    sellingPlanSelect.addEventListener("change", e => updatePrice);

    function updatePrice(price) {
      if (!price) price = getCurrentPrice();
      updateSubmitBtnPrice(price);
      updateMobilePrice(price);
    }
    function updateSubmitBtnPrice(price) {
      if (!price) price = getCurrentPrice();
      submitBtnPriceText.textContent = price;
    }
    function updateMobilePrice(price) {
      if (!mobilePriceText) return;
      if (!price) price = getCurrentPrice();
      mobilePriceText.textContent = price;
    }
    function getCurrentPrice(target) {
      if (!target) {
        target = widget.querySelector("input[type='radio']:checked");
      }
      if (!target) { console.warn("something went wrong with getCurrentPrice"); return; }
      if (target.nextSibling.querySelector(".rc-radio__price")) {
        return target.nextSibling.querySelector(".rc-radio__price").textContent;
      }
      else {
        return "$" + target.nextSibling.textContent.split("$")[1];
      }
    }
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    super.updateOptions();
    super.updateVariant();
    super.toggleAddButton(false, '');
    super.handleErrorMessage();
    super.filterOptions();

    if (!this.currentVariant) {
      super.toggleAddButton(true, '');
      super.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      super.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    super.updateVariantInput();
    this.renderProductInfo();
    this.updateColorLabel();
    this.updateStickyImage();
    this.updateStickyProductTitle();
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  renderProductInfo() {
    const destinationPrice = document.querySelector(
      `#price-${this.dataset.sectionId}`,
    );

    if (destinationPrice && this.currentVariantPrice?.price_html) {
      destinationPrice.classList.remove('visually-hidden');
      destinationPrice.innerHTML = this.currentVariantPrice.price_html;
    }
  }

  updateColorLabel() {
    const colorLabel = this.querySelector('[data-color-label]');
    if (!colorLabel) return;
    colorLabel.textContent = this.currentVariant.title;
  }

  updateStickyImage() {
    const image = this.querySelector('[data-sticky-image]');
    if (!image) return;
    const imgSrc = this.currentVariant.png_image ?? this.currentVariant.featured_image.src;
    image.srcset = imgSrc;
  }

  updateStickyProductTitle() {
    const stickyBarTitle = this.querySelector("sticky-bar-title");
    if (!stickyBarTitle) return;
    stickyBarTitle.textContent = this.currentVariant.title;
  }
}

customElements.define('main-product-selector', MainProductSelector);
